import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material';

const ModalVerifySuperAppsPassword = ({ open, onClose, onConfirm, password, setPassword, isLoading }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="verify-superapps-password-title"
      PaperProps={{
        sx: {
          borderRadius: 3,
          border: '1px solid var(--border-subtle)',
          boxShadow: 'var(--shadow-card)',
          p: 1,
        },
      }}
    >
      <DialogTitle id="verify-superapps-password-title" sx={{ fontWeight: 700, pb: 1 }}>
        Verifikasi Password SuperApps
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          name="superapps_password"
          label="Password SuperApps"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button onClick={onClose} color="primary" variant="outlined" disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus disabled={isLoading}>
          {isLoading ? 'Verifying...' : 'Submit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalVerifySuperAppsPassword;
